<template>
    <div class="dashboard-page">
      <h1 class="page-title">Dashboard</h1>
      <div class="sidesWrapper">
        <div style="width:100%">
          <b-row>
            <b-col lg="4" md="6" xs="12">
              <Widget>
                <div class="clearfix">
                  <div class="row flex-nowrap">
                    <div class="col-3">
                      <span class="widget-icon">
                        <i class="fa fa-user text-primary" />
                      </span>
                    </div>
                    <div class="col-9">
                      <h6 class="m-0">PERMOHONAN</h6>
                      <p class="h2 m-0 fw-normal">{{ dataDashboard.permohonan }}</p>
                    </div>
                  </div>
                  <!-- <div class="row flex-nowrap">
                    <div class="col-6">
                      <h6 class="m-0">Registrations</h6>
                      <p class="value5">+830</p>
                    </div>
                    <div class="col-6">
                      <h6 class="m-0">Bounce Rate</h6>
                      <p class="value5">4.5%</p>
                    </div>
                  </div> -->
                </div>
              </Widget>
            </b-col>
            <b-col lg="4" md="6" xs="12">
              <Widget>
                <div class="clearfix">
                  <div class="row flex-nowrap">
                    <div class="col-3">
                      <span class="widget-icon">
                        <i class="fa fa-list-alt text-primary" />
                      </span>
                    </div>
                    <div class="col-9">
                      <h6 class="m-0">PROSES</h6>
                      <p class="h2 m-0 fw-normal">{{ dataDashboard.proses }}</p>
                    </div>
                  </div>
                  <!-- <div class="row flex-nowrap">
                    <div class="col-6">
                      <h6 class="m-0">Registrations</h6>
                      <p class="value5">+830</p>
                    </div>
                    <div class="col-6">
                      <h6 class="m-0">Bounce Rate</h6>
                      <p class="value5">4.5%</p>
                    </div>
                  </div> -->
                </div>
              </Widget>
            </b-col>
            <b-col lg="4" md="6" xs="12">
              <Widget>
                <div class="clearfix">
                  <div class="row flex-nowrap">
                    <div class="col-3">
                      <span class="widget-icon">
                        <i class="fa fa-file-text-o text-primary" />
                      </span>
                    </div>
                    <div class="col-9">
                      <h6 class="m-0">SELESAI</h6>
                      <p class="h2 m-0 fw-normal">{{ dataDashboard.selesai }}</p>
                    </div>
                  </div>
                  <!-- <div class="row flex-nowrap">
                    <div class="col-6">
                      <h6 class="m-0">Registrations</h6>
                      <p class="value5">+830</p>
                    </div>
                    <div class="col-6">
                      <h6 class="m-0">Bounce Rate</h6>
                      <p class="value5">4.5%</p>
                    </div>
                  </div> -->
                </div>
              </Widget>
            </b-col>
          </b-row>
          <b-row>
            <b-col xs="12" md="12">
              <Widget title="<h5>Data Permohonan Berusaha</h5>" bodyClass="widget-table-overflow" customHeader>
                <template v-if="itemsWithNumber.length == 0">
                      <div class="text-center py-4">
                        <img
                          src="@/assets/empty.png"
                          alt="Tidak ada data"
                          class="img-fluid mb-2"
                          style="max-width: 120px;"
                        />
                        <div class="text-muted">Tidak ada data!</div>
                      </div>
                      
                    </template>

                    <template v-else>
                      <div class="my-3">
                   
                  <div  class="table-responsive mb-3 datatables">
                   
                    <b-table  striped hover :items="itemsWithNumber" :fields="fields" responsive="sm" :per-page="perPage"
                      :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter"
                      :filter-included-fields="filterOn" @filtered="onFiltered">
                      <template #cell(tanggal_permohonan)="data">
                        {{ format_date(data.item.tanggal_pada_permohonan) }}
                      </template>
                      <template #cell(status_permohonan)="data">
                        <h6>
                        <b-badge v-if="data.item.status_permohonan =='Selesai'" variant="success" style="font-size: 10px;">{{ data.item.status_permohonan }}</b-badge>
                        <b-badge v-else-if="data.item.status_permohonan =='Perbaikan Persyaratan' || data.item.status_permohonan =='Penolakan'" variant="danger" style="font-size: 10px;">{{ data.item.status_permohonan }}</b-badge>
                        <b-badge v-else-if="data.item.status_permohonan =='Permohonan telah dibuat oleh pemohon'" variant="warning" style="font-size: 10px;">{{ data.item.status_permohonan }}</b-badge>
                        <b-badge v-else variant="info" style="font-size: 10px;">{{ data.item.status_permohonan }}</b-badge>
                        </h6>
                        
                      </template>
                    </b-table>
                  </div>
                  <div class="row mb-md-2">
                    <div class="col-sm-12 col-md-6 mx-3">
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                          <b-form-select class="form-control form-control-sm form-select form-select-sm" v-model="perPage"
                            size="sm" :options="pageOptions"></b-form-select>
                        </label>
                      </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
  
                    </div>
                    <!-- End search -->
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="dataTables_paginate paging_simple_numbers float-end m-3">
                        <ul class="pagination pagination-rounded mb-0">
                          <!-- pagination -->
                          <b-pagination first-text="First" prev-text="Prev" next-text="Next" last-text="Last"
                            v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                    </template>
              </Widget>
            </b-col>
          </b-row>

          <b-row>
            <b-col xs="12" md="12">
              <Widget title="<h5>Data Permohonan Non Berusaha</h5>" bodyClass="widget-table-overflow" customHeader>
                <div class="my-3">
                  <template v-if="itemsWithNumberNonber.length == 0">
                      <div class="text-center py-4">
                        <img
                          src="@/assets/empty.png"
                          alt="Tidak ada data"
                          class="img-fluid mb-2"
                          style="max-width: 120px;"
                        />
                        <div class="text-muted">Tidak ada data!</div>
                      </div>
                      
                    </template>

                    <template v-else>
                      <div class="table-responsive mb-3 datatables"> 
                    <b-table striped hover :items="itemsWithNumberNonber" :fields="fields" responsive="sm" :per-page="perPageNonber"
                      :current-page="currentPageNonber" :sort-by.sync="sortByNonber" :sort-desc.sync="sortDescNonber" :filter="filterNonber"
                      :filter-included-fields="filterOnNonber" @filtered="onFilteredNonber">
                      <template #cell(tanggal_permohonan)="data">
                        {{ format_date(data.item.tanggal_permohonan) }}
                      </template>
                      <template #cell(status_permohonan)="data">
                        <h6>
                        <b-badge v-if="data.item.status_permohonan =='Selesai'" variant="success" style="font-size: 10px;">{{ data.item.status_permohonan }}</b-badge>
                        <b-badge v-else-if="data.item.status_permohonan =='Perbaikan Persyaratan' || data.item.status_permohonan =='Penolakan'" variant="danger" style="font-size: 10px;">{{ data.item.status_permohonan }}</b-badge>
                        <b-badge v-else-if="data.item.status_permohonan =='Permohonan telah dibuat oleh pemohon'" variant="warning" style="font-size: 10px;">{{ data.item.status_permohonan }}</b-badge>
                        <b-badge v-else variant="info" style="font-size: 10px;">{{ data.item.status_permohonan }}</b-badge>
                        </h6>
                        
                      </template>
                    </b-table>
                  </div>
                  <div class="row mb-md-2">
                    <div class="col-sm-12 col-md-6 mx-3">
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                          <b-form-select class="form-control form-control-sm form-select form-select-sm" v-model="perPageNonber"
                            size="sm" :options="pageOptionsNonber"></b-form-select>
                        </label>
                      </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
  
                    </div>
                    <!-- End search -->
                  </div>
                    
                  
                  <div class="row">
                    <div class="col">
                      <div class="dataTables_paginate paging_simple_numbers float-end m-3">
                        <ul class="pagination pagination-rounded mb-0">
                          <!-- pagination -->
                          <b-pagination first-text="First" prev-text="Prev" next-text="Next" last-text="Last"
                            v-model="currentPageNonber" :total-rows="rowsNonber" :per-page="perPageNonber"></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                  </template>
                </div>
              </Widget>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex';
  import Widget from '@/components/Widget/Widget';
  import MainChart from './components/MainChart/MainChart';
  import BigStat from './components/BigStat/BigStat';
  import Calendar from '../Visits/components/Calendar/Calendar';
  import TaskContainer from './components/TaskContainer/TaskContainer';
  import mock from './mock';
  import axios from 'axios';
  import moment from 'moment'
  
  import { Chart } from 'highcharts-vue';
  import IzinProvChart from './components/MainChart/IzinProvChart.vue';
  import IzinPNBPChart from './components/MainChart/IzinPNBPChart.vue';
  import IzinYearChart from './components/MainChart/IzinYearChart.vue';
  
  
  export default {
    name: 'Dashboard',
    components: {
      Widget,
      MainChart,
      BigStat,
      Calendar,
      TaskContainer,
      highcharts: Chart,
      IzinProvChart,
      IzinYearChart,
      IzinPNBPChart
  },
    data() {
      return {
        mock,
        baseapi: localStorage.getItem("baseapi"),
        user: JSON.parse(localStorage.getItem('user')),
        dataPermohonan: [],
        dataPermohonanNonber: [],
        dataDashboard: [],
        table: [{
          id: 0,
          name: 'Mark Otto',
          email: 'ottoto@wxample.com',
          product: 'ON the Road',
          price: '$25 224.2',
          date: '11 May 2017',
          city: 'Otsego',
          status: 'Sent',
        },
        {
          id: 1,
          name: 'Jacob Thornton',
          email: 'thornton@wxample.com',
          product: 'HP Core i7',
          price: '$1 254.2',
          date: '4 Jun 2017',
          city: 'Fivepointville',
          status: 'Sent',
        },
        {
          id: 2,
          name: 'Larry the Bird',
          email: 'bird@wxample.com',
          product: 'Air Pro',
          price: '$1 570.0',
          date: '27 Aug 2017',
          city: 'Leadville North',
          status: 'Pending',
        },
        {
          id: 3,
          name: 'Joseph May',
          email: 'josephmay@wxample.com',
          product: 'Version Control',
          price: '$5 224.5',
          date: '19 Feb 2018',
          city: 'Seaforth',
          status: 'Declined',
        },
        {
          id: 4,
          name: 'Peter Horadnia',
          email: 'horadnia@wxample.com',
          product: 'Let\'s Dance',
          price: '$43 594.7',
          date: '1 Mar 2018',
          city: 'Hanoverton',
          status: 'Sent',
        }],
        fields: [
          'no',
          { key: "nama_pemohon", sortable: true },
          { key: "instansi_pemohon", sortable: true },
          { key: "nomor_permohonan", sortable: true },
          { key: "jenis_kegiatan", sortable: true },
          { key: "status_permohonan", label: "Status", sortable: true },
          { key: "tanggal_permohonan", label: "Tanggal Permohonan" },
        ],
        optionsDatatable: {
          perPage: 10,
          pagination: { chunk: 10, dropdown: false },
          texts: { filter: '', count: '', limit: '' },
          columnsClasses: { id: 'width-100' },
          skin: 'table table-striped',
          sortIcon: {
            base: 'fa text-muted', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort',
          },
        },
        items: [],
        itemsNonber: [],
        currentPage: 1,
        currentPageNonber: 1,
        perPage: 10,
        perPageNonber: 10,
        pageOptions: [10, 25, 50, 100],
        pageOptionsNonber: [10, 25, 50, 100],
        filter: null,
        filterNonber: null,
        filterOn: [],
        filterOnNonber: [],
        sortBy: "name",
        sortByNonber: "name",
        sortDesc: false,
        sortDescNonber: false,
        totalRows: 1,
        totalRowsNonber: 1,
      };
    },
    methods: {
      ...mapActions('dashboard', ['receiveDataRequest']),
      getRandomData() {
        const arr = [];
  
        for (let i = 0; i < 25; i += 1) {
          arr.push(Math.random().toFixed(1) * 10);
        }
  
        return arr;
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      onFilteredNonber(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRowsNonber = filteredItems.length;
        this.currentPageNonber = 1;
      },
      
      loaddata() {
        axios.get(this.baseapi + 'api/permohonan?filter=npwp_pemohon,=,'+this.user.npwp, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken
          }
        }).then(response => {
          this.dataPermohonan = response.data.data;
        }).catch(error => {
          console.log(error)
          return error
        });
      },

      loaddatanonber() {
        axios.get(this.baseapi + 'api/permohonan_nonberusaha?filter=id_pembuat,=,'+this.user.id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken
          }
        }).then(response => {
          this.dataPermohonanNonber = response.data.data;
        }).catch(error => {
          console.log(error)
          return error
        });
      },

      loadDataDashboard() {
        axios.get(this.baseapi + 'api/dashboard/web', {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken
          }
        }).then(response => {
          this.dataDashboard = response.data.data;
        }).catch(error => {
          console.log(error)
          return error
        });
      },
      format_date(value) {
        if (value) {
          return moment(String(value)).format('DD MMMM YYYY')
        }
      },
    },
    computed: {
      ...mapState('dashboard', [
        'visits',
        'performance',
        'server',
        'revenue',
        'mainChart',
        'isReceiving',
      ]),
      itemsWithNumber() {
        return this.dataPermohonan.map((d, index) => ({ ...d, no: index + 1 }))
      },
      rows() {
        return this.dataPermohonan.length;
      },
      itemsWithNumberNonber() {
        return this.dataPermohonanNonber.map((d, index) => ({ ...d, no: index + 1 }))
      },
      rowsNonber() {
        return this.dataPermohonanNonber.length;
      },
      donut() {
        let { danger, warning, primary } = this.appConfig.colors;
        let series = [
          {
            name: 'Revenue',
            data: this.revenue.map(s => {
              return {
                name: s.label,
                y: s.data
              }
            })
          }
        ];
        return {
          chart: {
            type: 'pie',
            height: 120
          },
          credits: {
            enabled: false
          },
          title: false,
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: false
              },
              borderColor: null,
              showInLegend: true,
              innerSize: 60,
              size: 100,
              states: {
                hover: {
                  halo: {
                    size: 1
                  }
                }
              }
            }
          },
          colors: [danger, warning, primary],
          legend: {
            align: 'right',
            verticalAlign: 'middle',
            layout: 'vertical',
            itemStyle: {
              color: '#495057',
              fontWeight: 100,
              fontFamily: 'Montserrat'
            },
            itemMarginBottom: 5,
            symbolRadius: 0
          },
          exporting: {
            enabled: false
          },
          series
        };
      }
    },
    mounted() {
      this.receiveDataRequest();
      this.loaddata()
      this.loaddatanonber()
      this.loadDataDashboard()
      this.totalRows = this.items.length;
      this.totalRowsNonber = this.itemsNonber.length;
    },
  };
  </script>
  
  <style src="./Dashboard.scss" lang="scss" />
  